const translations = {
    en:{
        'Opciones de compra': 'Purchase Options',
        'Compra única': 'One-Time Purchase',
        'Suscríbete y Ahorra': 'Subscribe & Save',
        'Suscríbete y Ahorra 25%': 'Subscribe & Save 25%',
        'Suscríbete y Ahorra 20%': 'Subscribe & Save 20%',
        'Suscríbete y Ahorra 18%': 'Subscribe & Save 18%',
        'Suscríbete y Ahorra 15%': 'Subscribe & Save 15%',
        'Suscríbete y Ahorra 10%': 'Subscribe & Save 10%',
        'Envíos cada:': '📅 Ship every:',
        '30 Días': '30 Days',
        '30 días': '30 Days',
        '60 Días': '60 Days',
        '60 días': '60 Days',
        '90 Días': '90 Days',
        '90 días': '90 Days',
        '120 Días': '120 Days',
        '120 días': '120 Days',
        '365 Días': '365 Days',   
        'Ideal para 4 personas': 'Ideal for 4 people',
        'Ideal para 2 personas': 'Ideal for 2 people',
        'Ideal para 1 persona': 'Ideal for 1 person',
        '4 personas 30 días': 'Ideal for 4 people',
        '2 personas 60 días': 'Ideal for 2 people',
        '1 persona 90 días': 'Ideal for 1 person',
        'Si pones dos lavavajillas al día': 'If you run two loads a day',
        'Si pones un lavavajillas al día': 'If you run one load a day',
        'Si pones 5 lavavajillas por semana': 'If you run five loads a week',
        'Si pones un lavavajillas día sí, día no': 'If you run one load every other day',
        'Ideal Casas': 'Ideal for houses',
        'Ideal Pisos Grandes': 'Ideal for large apartments',
        'Ideal Pisos Medianos': 'Ideal for medium apartments',
        'Ideal Pisos Pequeños': 'Ideal for small apartments',
        'Sin Permanencia': '✅ No Commitment',
        'Cancela en cualquier momento': '✅ Cancel anytime',
    },
    ca:{
        'Opciones de compra': 'Opcions de compra',
        'Compra única': 'Compra única',
        'Suscríbete y Ahorra': 'Subscriu-te i Estalvia',
        'Suscríbete y Ahorra 25%': 'Subscriu-te i Estalvia 25%',
        'Suscríbete y Ahorra 20%': 'Subscriu-te i Estalvia 20%',
        'Suscríbete y Ahorra 18%': 'Subscriu-te i Estalvia 18%',
        'Suscríbete y Ahorra 15%': 'Subscriu-te i Estalvia 15%',
        'Suscríbete y Ahorra 10%': 'Subscriu-te i Estalvia 10%',
        'Envíos cada:': '📅 Enviaments Cada:',
        '30 Días': '30 Dies',
        '60 Días': '60 Dies',
        '90 Días': '90 Dies',
        '120 Días': '120 Dies',
        '30 días': '30 Dies',
        '60 días': '60 Dies',
        '90 días': '90 Dies',
        '120 días': '120 Dies',
        '365 Días': '365 Dies',
        'Ideal para 4 personas': 'Ideal per a 4 persones',
        'Ideal para 2 personas': 'Ideal per a 2 persones',
        'Ideal para 1 persona': 'Ideal per a 1 persona',
      '4 personas 30 días': 'Ideal per a 4 persones',
        '2 personas 60 días': 'Ideal per a 2 persones',
        '1 persona 90 días': 'Ideal per a 1 persona',
        'Si pones dos lavavajillas al día': 'Si poses dos rentavaixelles al dia',
        'Si pones un lavavajillas al día': 'Si poses un rentavaixelles al dia',
        'Si pones 5 lavavajillas por semana': 'Si poses cinc rentavaixelles per setmana',
        'Si pones un lavavajillas día sí, día no': 'Si poses un rentavaixelles dia sí, dia no',
        'Ideal Casas': 'Ideal per cases',
        'Ideal Pisos Grandes': 'Ideal per pisos grans',
        'Ideal Pisos Medianos': 'Ideal per pisos mitjans',
        'Ideal Pisos Pequeños': 'Ideal per pisos petits',
        'Sin Permanencia': '✅ Sense permanència',
        'Cancela en cualquier momento': '✅ Cancel·la en qualsevol moment',

    },
};